import SectionHead from "./SectionHead";
import { HERO_LEAD, HERO_STACK, HERO_MINI } from "../../../mocks/chigua";

export default function Hero() {
  return (
    <section id="hero" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-6 md:pt-8">
        <SectionHead
          no="01"
          kicker="Cover · 今日封面"
          title="今日封面 · 全网围观头条"
          sub="多线现场同时开播：停车场手电筒、电梯口名场面、隔江对窗拉帘——封面卡同步滚动，蹲哪条都行，蹲错了也别慌，评论区会替你把前因后果补齐。"
          right="围观全场"
        />

        {/* 多卡并列 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          {/* 主卡 */}
          <article className="lg:col-span-7 relative group overflow-hidden rounded-lg bg-foreground-950">
            <img
              src={HERO_LEAD.cover}
              alt="抓奸实录今日头条 深夜停车场直播合集"
              title="抓奸实录今日头条 深夜停车场直播合集"
              className="absolute inset-0 h-full w-full object-cover object-top opacity-95"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20" />
            <div className="relative h-[380px] md:h-[460px] flex flex-col justify-end p-5 md:p-7">
              <div className="flex items-center gap-2 mb-3 flex-wrap">
                <span className="mast-tag bg-primary-500">Live · 直播中</span>
                <span className="inline-flex items-center gap-1 text-[11px] text-background-50/90 bg-black/30 rounded-sm px-2 py-1 whitespace-nowrap">
                  <i className="ri-fire-fill text-accent-400" /> 热度 {HERO_LEAD.heat}
                </span>
              </div>
              <h3 className="font-heading text-2xl md:text-[34px] leading-snug font-black text-background-50">
                {HERO_LEAD.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-background-100/85 leading-relaxed max-w-2xl">{HERO_LEAD.desc}</p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href="#rank"
                  className="inline-flex items-center gap-2 rounded-md bg-primary-600 hover:bg-primary-500 px-5 py-2.5 text-sm text-background-50 font-medium transition-colors whitespace-nowrap"
                >
                  <i className="ri-eye-2-line" /> 进去围观
                </a>
                <div className="flex items-center gap-4 text-xs text-background-50/80">
                  <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {HERO_LEAD.comments}</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {HERO_LEAD.views}</span>
                  <span className="inline-flex items-center gap-1 hidden sm:inline-flex"><i className="ri-time-line" /> {HERO_LEAD.meta}</span>
                </div>
              </div>
            </div>
          </article>

          {/* 右侧纵列两张封面 */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-5">
            {HERO_STACK.map((c) => (
              <article key={c.id} className="group relative overflow-hidden rounded-lg bg-foreground-950">
                <img
                  src={c.cover}
                  alt={`抓奸实录神评论 ${c.title}`}
                  title={`抓奸实录网友热议 ${c.title}`}
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
                <div className="relative h-[250px] md:h-[218px] flex flex-col justify-end p-4">
                  <span className="mast-tag bg-accent-500 self-start mb-2">{c.tag}</span>
                  <h3 className="font-heading text-base font-bold text-background-50 leading-snug line-clamp-3">
                    {c.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-[11px] text-background-50/80">
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {c.comments}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {c.views}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* 热榜速览条 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mt-4 md:mt-5">
          {HERO_MINI.map((m, i) => (
            <a
              key={m.id}
              href="#rank"
              className="group flex items-start gap-3 rounded-md border border-background-200/80 bg-background-50 p-3 hover:border-primary-300 transition-colors"
            >
              <span
                className={
                  i < 3
                    ? "font-heading text-2xl font-black leading-none text-primary-600"
                    : "font-heading text-2xl font-black leading-none text-foreground-300"
                }
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[13px] font-medium text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {m.title}
                </span>
                <span className="mt-1.5 inline-flex items-center gap-1 text-[11px] text-primary-600">
                  <i className="ri-fire-fill" /> 热 {m.hot}
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}